// extracted by mini-css-extract-plugin
export default {"weather":"WeatherScreen_weather__Lcmi8","weather__container":"WeatherScreen_weather__container__C1Hw3","title":"WeatherScreen_title__SNnSC"};